import styled from 'styled-components';

export const IFrame = styled.iframe`
    border: none;
    height: calc(100vh - 200px);
    max-height: 800px;
    margin-bottom: 20px;
    margin-top: 20px;
    max-width: 800px;
    width: calc(100vh - 300px);
`;
